export const getColor = (active?: boolean) => {
  if (active) return "#1062D0";
  return "#ABBACC";
};
